import React, { useEffect, useRef } from 'react';

interface Props {
  onClickOutside: () => void;
  children: any;
}

/**
 * Click away listener wrapper.
 *
 * @param onClickOutside Function called when click away event occurs
 * @param children any children components
 * @returns
 */
const ClickAwayListener = ({ onClickOutside, children }: Props) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  return <div ref={ref}>{children}</div>;
};

export default ClickAwayListener;
